import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../../theme';
import ListOption from '../ListOption/ListOption';
const ListOptions = ({ className, options }) => {
    const { ListOptions: css } = useTheme('Entities').FareGroupV2;
    return (React.createElement("div", { className: cn(css.root, className) }, options.map((option, index) => (React.createElement(ListOption, Object.assign({ key: index, className: css.option }, option))))));
};
export default ListOptions;
